<script setup lang="ts">
import type { Icons } from '@/components/base/BaseIcon.vue'
import type { CustomVars, I18nStrings } from './interfaces'

type CategoryType = 'variable' | 'link' | 'webapp'

defineProps<{
  categoryType: CategoryType
  icon?: Icons
  customVars: CustomVars[]
  i18nStrings: I18nStrings
  stickyTopClass: string
  isSelected: (customVar: CustomVars) => boolean
}>()

const emit = defineEmits<{
  varClicked: [customVar: CustomVars, event: MouseEvent]
}>()

const { t } = useI18n()
</script>

<template>
  <li
    v-if="customVars.length > 0"
    class="sticky bg-white px-4 pt-2 pb-1 flex items-center gap-1 text-xs font-semibold uppercase text-muted-foreground"
    :class="stickyTopClass"
  >
    <BaseIcon v-if="icon" :name="icon" class="size-4" aria-hidden="true" />
    <span>
      {{ t(`ui.textareaWithVars.dropdownVars.categories.${categoryType}.title`) }}
    </span>
  </li>
  <li v-for="customVar in customVars" :key="customVar.code" @click="emit('varClicked', customVar, $event)">
    <VarListItem :custom-var="customVar" :i18n-strings="i18nStrings" :is-selected="isSelected(customVar)" />
  </li>
</template>
